import { z } from 'zod';
import { RuleConditionZod } from './rule.condition.zod';
import { RuleEffectZod } from './rule.effect.zod';

export const RuleSchemaZod = z.object({
  id: z.string().min(1),
  when: RuleConditionZod,
  then: z.array(RuleEffectZod),
  else: z.array(RuleEffectZod).optional(),
}).strict();

export type RuleSchema = z.infer<typeof RuleSchemaZod>;
